import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lmc-env/environment';

@Injectable({
	providedIn: 'root',
})
export class RapidUserAccountService {
	private readonly uri: string = `${environment.DO_URL}/v2`;

	constructor(private readonly http: HttpClient) { }

	createRapidUserAccount(data: any): Observable<any> {
		return this.http.post(`${this.uri}/rapid-user-account`, data);
	}

	getRapidUserAccount(id: any): Observable<any> {
		return this.http.get(`${this.uri}/rapid-user-account/${id}`);
	}
}
